import React, { useEffect, useRef, useState } from "react";
import { Table, Button, Modal } from "react-bootstrap";
import Layout from "../../components/Layout";
import { useLocation, useNavigate } from "react-router-dom";
import { MdModeEdit, MdDelete } from "react-icons/md";
import ToastFile from "../../utils/ToastFile";
import {
  deleteAddressByID,
  uploadBulkStreetData,
  getAllStreetbyRoute,
  deleteRouteByID,
  getAllParcelAddressbyRoute,
  getAllRoutebyContractor,
  uploadBulk,
} from "../../api/RouteApi";
import DeleteModel from "../../components/DeleteModel";
import Loader from "../../components/Loader";
import { FaDownload, FaEye, FaFileUpload, FaUpload } from "react-icons/fa";
import * as XLSX from "xlsx";
import ButtonLoader from "../../components/ButtonLoader";

const PanelAddress = () => {
  const { state } = useLocation();
  const fetched = useRef(false);
  const user = JSON.parse(localStorage.getItem("user"));
  const navigate = useNavigate();
  const [isLoading, setIsloading] = useState(true);
  const [isButtonLoading, setIsButtonloading] = useState(false);
  const [route, setRoute] = useState(null);
  const [parcelAddress, setParcelAddress] = useState([]);
  const [file, setFile] = useState(null);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteIndex, setDeleteIndex] = useState(0);
  const [showUploadModel, setShowUploadModal] = useState(false);
  const [excelData, setExcelData] = useState([]);

  useEffect(() => {
    if (state?.route) {
      setRoute(state?.route);
    }
    if (fetched.current) return;
    fetched.current = true;
    getPanelStreet(state?.route);
  }, []);

  const getPanelStreet = (route) => {
    setIsloading(true);
    getAllStreetbyRoute(
      route.route_id
    )
      .then((res) => {
        if (res.status === 200) {
          setParcelAddress(res?.data?.data?.streets);
        } else {
          ToastFile("Failed to fetch address", "error");
        }
      })
      .catch((err) => {
        console.error("Error fetching address:", err);
        ToastFile("Error fetching address", "error");
      })
      .finally(() => {
        setIsloading(false);
      });
  };

  const deleteParcelAddress = () => {
    deleteAddressByID(parcelAddress[deleteIndex]._id)
      .then((res) => {
        if (res.status === 200) {
          ToastFile("Address deleted", "deleted");
          fetched.current = false;
          getPanelStreet(route);
        } else {
          ToastFile("Failed to delete parcel address", "error");
        }
      })
      .catch((err) => {
        console.error("Error deleting parcel address:", err);
        ToastFile("Error deleting parcel address", "error");
      })
      .finally(() => {
        setDeleteIndex(0);
        setDeleteModal(false);
      });
  };

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();

    reader.onload = (event) => {
      const data = new Uint8Array(event.target.result);
      const workbook = XLSX.read(data, { type: "array" });

      // Read first sheet only
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];

      // Convert sheet to JSON
      const jsonData = XLSX.utils.sheet_to_json(worksheet);
      console.log("Excel to JSON:", jsonData);
      setExcelData(jsonData);
    };

    reader.readAsArrayBuffer(file);
  };

  const handleUploadToServer = async () => {
    setIsButtonloading(true);
    let payload = {
      data: excelData,
      route_id: route?.route_id,
      tenant_id: user?.tenant_id,
      createdBy: user?.user_id,
      createdAt: new Date(),
      modifiedBy: user?.user_id,
      modifiedAt: new Date()
    };
    await uploadBulkStreetData(payload)
      .then((res) => {
        if (res.status === 200) {
          ToastFile("File Uploaded successfully", "success");
          getPanelStreet(route);
        } else {
          ToastFile("Failed to upload file", "error");
        }
      })
      .catch(() => {
        ToastFile("Failed to upload file", "error");
      })
      .finally(() => {
        setIsButtonloading(false);
        setShowUploadModal(false);
      });
  };

  return (
    <Layout>
      <DeleteModel
        showModal={deleteModal}
        setShowModal={setDeleteModal}
        onYes={deleteParcelAddress}
      />
      <Modal
        show={showUploadModel}
        onHide={() => setShowUploadModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <div style={{ fontSize: 15 }}>
              Select File :{" "}
              <input
                type="file"
                accept=".xlsx, .xls"
                onChange={handleFileUpload}
              />
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex justify-content-end align-item-center">
            <Button
              variant="primary"
              type="submit"
              onClick={handleUploadToServer}
              style={{minWidth:"98px"}}
            >
              {isButtonLoading ? <ButtonLoader width="20px" height="20px"/> : "Submit" }
            </Button>
            <Button
              variant="white"
              className="border-1 border-dark ms-2"
              onClick={() => setShowUploadModal(false)}
            >
              Cancel
            </Button>
          </div>
        </Modal.Body>
      </Modal>
      <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center mb-3 gap-3">
        <span
            style={{
              fontSize: "22px",
              fontWeight: 600,
              minWidth: "140px",
            }}
          >
        Panel Address ({route?.routeName})
          </span>
        <div>
          <a
            href="https://postmatedev.onrender.com/documents/StreetRouteTemplate.xlsx"
            style={{ color: "#ec8e24", marginRight: 10 }}
          >
            Download Template
          </a>
          <Button onClick={() => setShowUploadModal(true)} className="bg-dark">
            {"Upload"}
          </Button>
         
        </div>
      </div>

      {/* Table Section - Mobile Responsive */}
      <div className="table-responsive d-none d-md-block">
        <Table striped bordered hover className="table-sm">
          <thead className="table-dark">
            <tr style={{ textAlign: "center" }}>
              <th className="text-nowrap">Sr. No.</th>
              <th className="text-nowrap">Street Name</th>
              <th className="text-nowrap d-none d-lg-table-cell">Landmark</th>
              {/* <th className="text-nowrap">Actions</th> */}
            </tr>
          </thead>
          {isLoading ? (
            <tbody>
              <tr>
                <td colSpan="4">
                  <Loader />
                </td>
              </tr>
            </tbody>
          ) : (
            <tbody>
              {parcelAddress.length === 0 ? (
                <tr>
                  <td colSpan="4" className="text-center">
                    No route found
                  </td>
                </tr>
              ) : (
                parcelAddress.map((c, idx) => (
                  <tr key={idx}>
                    <td className="text-nowrap">
                      <div className="fw-bold" style={{ textAlign: "center" }}>
                        {idx+1}
                      </div>
                    </td>
                    <td className="text-nowrap">{c.streetName}</td>
                    <td className="text-nowrap d-none d-lg-table-cell">
                      {route?.routeName}
                    </td>
                    {/* <td className="text-nowrap" style={{ textAlign: "center" }}>
                      <button
                        className="btn btn-sm btn-outline-danger border-0"
                        onClick={() => {
                          setDeleteIndex(idx);
                          setDeleteModal(true);
                        }}
                        title="Delete"
                      >
                        <MdDelete size={16} />
                      </button>
                    </td> */}
                  </tr>
                ))
              )}
            </tbody>
          )}
        </Table>
      </div>

      {/* Mobile Card View for Small Screens */}
      <div className="d-md-none">
        {parcelAddress.length === 0 ? (
          <div className="text-center py-4">
            <p className="text-muted">No route found</p>
          </div>
        ) : (
          <div className="row g-3">
            {parcelAddress.map((c, idx) => (
              <div key={idx} className="col-12">
                <div className="card">
                  <div className="card-body">
                    <div className="d-flex justify-content-between align-items-start mb-3">
                      <div className="flex-grow-1">
                        <h6 className="card-title mb-1">{c.address}</h6>
                        <small className="text-muted d-block">
                          Street Name: {c.streetName}
                        </small>
                      </div>
                      <div className="d-flex gap-1">
                        <button
                          className="btn btn-sm btn-outline-danger border-0"
                          onClick={() => {
                            setDeleteIndex(idx);
                            setDeleteModal(true);
                          }}
                          title="Delete"
                        >
                          <MdDelete size={16} />
                        </button>
                      </div>
                    </div>

                    {c.landmark && (
                      <div className="mb-2">
                        <small className="text-muted d-block">Landmark</small>
                        <span className="small">{c.landmark}</span>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </Layout>
  );
};

export default PanelAddress;
